var _defs, _rect, _rect2, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFlagPt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    width: 27,
    height: 27,
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "100 0 1000 1000",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1,.cls-6{fill:red;}.cls-2{fill:#060;}.cls-3,.cls-4,.cls-7,.cls-8,.cls-9{fill:#ff0;}.cls-3,.cls-4,.cls-5,.cls-6,.cls-8,.cls-9{stroke:#000;}.cls-3,.cls-4{stroke-linecap:round;stroke-linejoin:round;fill-rule:evenodd;}.cls-3{stroke-width:0.57px;}.cls-4{stroke-width:0.55px;}.cls-11,.cls-5{fill:#fff;}.cls-5{stroke-width:0.67px;}.cls-6{stroke-width:0.51px;}.cls-8{stroke-width:0.5px;}.cls-9{stroke-width:0.5px;}.cls-10{fill:#039;}"))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    width: 1500,
    height: 1000
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    width: 600,
    height: 1000
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M795.6,655.1c-75.53-2.27-421.85-218.45-424.23-252.87l19.13-31.9C424.85,420.25,778.9,630.48,813.67,623L795.6,655.09"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M386.47,366c-6.77,18.23,90.38,78.29,207.26,149.38s217.66,115,225.13,108.72c.46-.81,3.68-6.35,3.38-6.31-1.4,2.11-4.8,2.78-10.12,1.25-31.58-9.11-113.94-46.92-215.94-108.77S405.45,391.41,391.66,367.19a14.66,14.66,0,0,1-1.51-7.12h-.33l-2.94,5.14-.4.8ZM797.38,656.1c-1.29,2.32-3.67,2.4-8.21,1.9-28.25-3.12-114-44.81-215.4-105.53-118-70.65-215.5-135-204.93-151.85l2.88-5.09.56.18c-9.5,28.51,192.37,144,204.26,151.31,116.81,72.36,215.29,114.62,224,103.64l-3.17,5.45h0Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M600.42,423.07C676,422.48,769.3,412.75,823,391.35l-11.56-18.79c-31.73,17.56-125.53,29.11-211.63,30.84C498,402.46,426.06,393,390,368.81l-10.91,20c66.21,28,134,34,221.3,34.26"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M826.1,391.78c-1.85,3-36.86,15-88.43,23.93-35,5.33-80.59,9.89-137.51,10-54.08,0-98.26-3.8-131.71-8.33C414.31,408.84,386.37,397,376,392.85c1-2,1.62-3.34,2.57-5.18,29.74,11.84,57.81,19,90.7,24A964.32,964.32,0,0,0,600,420.07a917.35,917.35,0,0,0,136.54-10.14c52.89-8.53,81.78-19.5,85.83-24.6l3.74,6.45ZM816,372.72c-5.73,4.6-34.3,14.73-84.55,22.76a910.37,910.37,0,0,1-130.66,9.16c-51.76.05-94.05-3.44-126.21-8.12-51-6.67-78.2-18.69-88-22.2,1-1.68,2-3.35,3-5,7.62,3.83,33.83,14.47,85.57,21.8,31.8,4.51,74.15,7.87,125.65,7.82a899,899,0,0,0,129.71-9.22c50.51-6.95,77.69-19.87,81.82-23.1l3.68,6.12Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M352.2,514.15c46.49,25,149.76,37.61,247.49,38.48,89,.14,204.89-13.76,248.24-36.73l-1.2-25c-13.56,21.2-137.78,41.53-248,40.69S386.12,513.71,352,491.67l.2,22.47"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M850.3,510.55v6c-6.51,7.79-47.36,19.56-98.59,27.85-39,6-89.82,10.49-153.16,10.49-60.17,0-108.15-4.29-145.37-10-58.82-8.57-96.44-23.57-104-28.05l0-7C371.9,524.93,433.37,536,454,539.35c37,5.67,84.67,9.93,144.54,9.93,63,0,113.59-4.48,152.33-10.42,36.75-5.31,89.11-19.11,99.42-28.31Zm0-21.23v6c-6.52,7.78-47.37,19.56-98.6,27.85-39,6-89.81,10.48-153.15,10.48-60.17,0-108.16-4.28-145.37-10-58.82-8.56-96.45-23.56-104-28l0-7c22.69,15.08,84.16,26.12,104.8,29.49,37,5.68,84.67,9.94,144.54,9.94,63,0,113.58-4.48,152.33-10.43,36.75-5.3,89.11-19.11,99.41-28.31Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M599.47,650.8c-106.93-.64-198.55-29.15-217.9-33.86L395.68,639c34.18,14.37,123.56,35.8,204.82,33.42s152.28-8.66,202.32-33l14.47-22.89c-34.11,16.06-150.17,34.09-217.82,34.26"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M808.25,634.3c-2.13,3.25-4.29,6.46-6.49,9.57-23.61,8.33-60.8,17.06-76.49,19.61C693.21,670.09,643.6,675,599.58,675c-94.72-1.39-172.26-19.93-208.74-35.75l-2.94-5.06.48-.76,5,1.94c64.87,23.21,137.73,32.47,206.75,34.13,43.84.15,87.73-5,123.23-11.37,54.42-10.91,76.43-19.13,83.18-22.86l1.72-1Zm12.54-20.69.17.2c-1.59,2.68-3.23,5.41-4.91,8.15-12.59,4.5-46.75,14.5-96.65,21.47-32.87,4.48-53.3,8.82-118.69,10.09-122.54-3.12-201.88-27.08-220.73-33l-2.79-5.36c71,18.54,143.55,31.48,223.52,32.81,59.83-1.28,85.28-5.68,117.88-10.13,58.18-9,87.49-18.62,96.29-21.39-.11-.16-.24-.32-.39-.5l6.31-2.35Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M822.07,494.4c.35,70.34-35.65,133.46-64.64,161.31-41,39.4-95.41,64.74-158.92,65.91-70.93,1.3-137.8-44.93-155.74-65.25-35.07-39.71-63.62-90.14-64.54-158.1,4.35-76.78,34.48-130.25,78.17-166.93s101.86-54.53,150.3-53.25C662.6,279.56,727.89,307,773,361.42c29.56,35.66,42.35,74.37,49.07,133Zm-223-240.86c136.21,0,248.24,110.85,248.24,246.76s-112,246.76-248.24,246.76S351.8,636.22,351.8,500.3,462.9,253.54,599.11,253.54"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M599.78,252.7c136.33,0,247.52,111.21,247.52,247.56S736.11,747.81,599.78,747.81,352.25,636.6,352.25,500.26,463.44,252.7,599.78,252.7ZM357.7,500.26c0,133.15,109.33,242.1,242.08,242.1s242.08-109,242.08-242.1S732.52,258.15,599.78,258.15,357.7,367.11,357.7,500.26Z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M600,273.27c124.32,0,226.73,102.06,226.73,226.77S724.3,726.79,600,726.79,373.24,624.75,373.24,500,475.65,273.28,600,273.28ZM378.69,500c0,121.72,99.95,221.31,221.29,221.31S821.26,621.75,821.26,500,721.32,278.72,600,278.72,378.69,378.32,378.69,500Z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M610,251.7H588.74l0,497.4h21.29Z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M607.83,248.86h5.39l0,503.13h-5.4l0-503.13Zm-21.06,0h5.44V752h-5.44V248.87Z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M847.47,509.84V491.45l-15-13.95-85-22.5L625,442.5,477.5,450l-105,25-21.2,15.7v18.39L405,485l127.5-20H655l90,10,62.5,15Z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M599.87,461.93c58.46-.11,115.18,5.53,160.17,14.29,46.42,9.28,79.09,20.89,90.26,33.93v6.46c-13.47-16.23-57.43-28.12-91.3-34.92-44.64-8.69-101-14.3-159.11-14.19-61.35.12-118.47,5.93-162.46,14.51-35.3,7-82.38,20.92-88.26,34.65v-6.73c3.23-9.5,38.28-23.69,87.46-33.54,44.32-8.64,101.55-14.35,163.26-14.47Zm0-21.24c58.46-.1,115.17,5.55,160.16,14.3,46.42,9.29,79.09,20.89,90.27,33.93l0,6.46c-13.47-16.22-57.43-28.12-91.29-34.92-44.65-8.69-101-14.29-159.12-14.18-61.35.11-118.19,5.92-162.19,14.5-34.06,6.46-83.06,20.92-88.53,34.65V488.7c3.23-9.39,39-24.1,87.46-33.54C481,446.52,538.19,440.81,599.9,440.7Z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M598.7,332.4c92.12-.46,172.48,12.88,209.24,31.71l13.41,23.2c-32-17.22-118.64-35.12-222.52-32.45-84.63.52-175.06,9.32-220.44,33.53l16-26.77c37.24-19.32,125.06-29.11,204.3-29.21"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M599.93,351.55c52.54-.14,103.31,2.82,143.69,10.11,37.6,7,73.46,17.5,78.59,23.15l4,7c-12.47-8.15-43.5-17.21-83.35-24.77-40-7.52-90.75-10-143-9.88-59.3-.2-105.38,2.93-144.92,9.83-41.82,7.82-70.83,19-78,24.31l3.89-7.42c13.91-7.1,36-15.65,73.06-22.33,40.89-7.47,87.46-9.71,146.06-10Zm0-21.21c50.29-.13,99.93,2.67,138.63,9.63,30.53,5.94,60.71,15.21,71.76,23.47l5.82,9.24c-9.89-11-47.09-21.4-79.94-27.23-38.4-6.63-86-9.25-136.27-9.67-52.77.15-101.54,3.38-139.38,10.27-36.1,6.87-59.4,15-69.26,21.36l5.12-7.72C410,352.53,432,346,459.63,340.58c38.13-6.94,87.19-10.09,140.27-10.24Z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M722.87,603.15c-45.54-8.5-91.17-9.74-123-9.36-153.51,1.8-203.11,31.52-209.16,40.52l-11.47-18.7c39.08-28.33,122.68-44.22,221.46-42.6,51.3.84,95.56,4.25,132.8,11.46l-10.59,18.68"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M599,591.15c42.7.64,84.62,2.4,125.08,10l-2.93,5.17c-37.57-6.94-77.63-9.59-122-9.38-56.66-.44-114,4.85-163.86,19.17-15.74,4.38-41.8,14.5-44.46,22.86l-2.91-4.8c.84-4.94,16.59-15.2,46-23.48,57.15-16.36,110.6-19.12,165.05-19.49Zm1.94-21.49c44.24.83,89.94,2.87,134.35,11.67l-3,5.38c-40.11-8-78.43-10.61-131-11.42-56.84.1-117.13,4.15-171.95,20.09-17.69,5.16-48.24,16.3-49.26,25.13L377,615.34c.66-8,27.1-18.47,50.89-25.39,55.24-16.06,115.69-20.19,173-20.29Z"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M819,618.45,800.5,647.07,747.5,600,610,507.5l-155-85L374.52,395l17.15-31.8L397.5,360l50,12.5,165,85,95,60,80,57.5L820,612.5Z"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M371.62,395.72c14.12-9.57,117.85,36.64,226.39,102.09,108.25,65.63,211.69,139.8,202.36,153.68l-3.07,4.83-1.41,1.11c.3-.21,1.86-2.11-.15-7.26-4.62-15.18-78-73.73-199.74-147.24C477.31,432.16,378.4,389.5,368.51,401.7l3.12-6ZM822.72,618c8.93-17.63-87.28-90.11-206.58-160.68-122-69.16-210-109.88-226-97.74l-3.56,6.5c0,.36.13-.44.88-1,2.92-2.55,7.76-2.38,9.95-2.42C425,363.1,504,399.45,614.87,463c48.57,28.29,205.18,128.73,204.58,157,0,2.43.2,2.93-.71,4.13l4-6.06Z"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M451.5,527.52a146.81,146.81,0,0,0,43.64,104.36c27,26.94,63.78,44,104.52,44A148.69,148.69,0,0,0,748.32,527.65h0v-198l-296.85-.35,0,198.19Z"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M457.05,527.8v.11a140.93,140.93,0,0,0,41.94,100A142.19,142.19,0,0,0,741.83,528h0V336l-284.6,0-.17,191.87M684.6,393.43V515.66l-.1,12.93h0a94.83,94.83,0,0,1-.6,10.58,83,83,0,0,1-24.37,49.27,85,85,0,0,1-60.11,24.85c-23.32,0-44.1-9.84-59.58-25.25a84.9,84.9,0,0,1-25.07-59.86l0-135.06,169.85.31Z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "castle3"
  }, /*#__PURE__*/React.createElement("g", {
    id: "castle"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M475.48,386.07c.33-13.8,10.13-17.07,10.2-17.11s10.57,3.52,10.54,17.24l-20.74-.12"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M467,369.23l-1.7,15.86,10.35,0c.1-13.12,9.94-15.31,10.17-15.26s10,2.9,10.24,15.26h10.37l-1.87-16-37.55.09h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M464.63,385.15H507a2,2,0,0,1,0,3.91H464.63a2,2,0,0,1,0-3.91Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M480,385.07c.05-8.28,5.66-10.62,5.69-10.62s5.85,2.42,5.9,10.62H480"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M465.53,362.63h40.61a1.77,1.77,0,0,1,0,3.52H465.53a1.77,1.77,0,0,1,0-3.52Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M466.38,366.18h38.84a1.78,1.78,0,0,1,0,3.52H466.38a1.78,1.78,0,0,1,0-3.52Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M478.93,339.7H482v2.17h2.24v-2.22h3.14v2.21h2.25v-2.22h3.14v5a1.3,1.3,0,0,1-1.37,1.3h-11a1.41,1.41,0,0,1-1.43-1.32v-5h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M490.48,346.43l.69,16.12-10.76,0,.71-16.13,9.35.05"
  }), /*#__PURE__*/React.createElement("path", {
    id: "cp1",
    className: "cls-8",
    d: "M477.35,353.9l.33,8.69H467.36l.3-8.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "cp1-2",
    "data-name": "cp1",
    className: "cls-8",
    d: "M503.87,353.9l.33,8.69H493.89l.29-8.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "cp2",
    className: "cls-8",
    d: "M465.75,347.6h3v2.18h2.19v-2.23H474v2.22h2.19v-2.23h3.08v5a1.29,1.29,0,0,1-1.34,1.3H467.15a1.4,1.4,0,0,1-1.4-1.32v-5Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "cp2-2",
    "data-name": "cp2",
    className: "cls-8",
    d: "M492.27,347.6h3v2.18h2.19v-2.23h3.08v2.22h2.2v-2.23h3.07v5a1.29,1.29,0,0,1-1.34,1.3h-10.8a1.39,1.39,0,0,1-1.39-1.32v-5Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M484.75,351.53a1.09,1.09,0,1,1,2.17,0v3.84h-2.17v-3.84"
  }), /*#__PURE__*/React.createElement("path", {
    id: "cp3",
    d: "M471.43,357.1a1,1,0,1,1,2.06,0v3h-2.06v-3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "cp3-2",
    "data-name": "cp3",
    d: "M498,357.1a1,1,0,1,1,2.06,0v3H498v-3"
  })), /*#__PURE__*/React.createElement("g", {
    id: "castle-2",
    "data-name": "castle"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M475.48,501.87c.33-13.8,10.13-17.07,10.2-17.11s10.57,3.51,10.54,17.24l-20.74-.13"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M467,485l-1.7,15.87,10.35,0c.1-13.12,9.94-15.31,10.17-15.26s10,2.9,10.24,15.26h10.37l-1.87-16L467,485h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M464.63,501H507a2,2,0,0,1,0,3.91H464.63a2,2,0,0,1,0-3.91Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M480,500.87c.05-8.28,5.66-10.62,5.69-10.62s5.85,2.42,5.9,10.62H480"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M465.53,478.42h40.61a1.78,1.78,0,0,1,0,3.53H465.53a1.78,1.78,0,0,1,0-3.53Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M466.38,482h38.84a1.79,1.79,0,0,1,0,3.53H466.38a1.79,1.79,0,0,1,0-3.53Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M478.93,455.5H482v2.18h2.24v-2.22h3.14v2.21h2.25v-2.22h3.14v5a1.3,1.3,0,0,1-1.37,1.3h-11a1.41,1.41,0,0,1-1.43-1.32v-5h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M490.48,462.22l.69,16.13-10.76,0,.71-16.13,9.35,0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "cp1-3",
    "data-name": "cp1",
    className: "cls-8",
    d: "M477.35,469.7l.33,8.69H467.36l.3-8.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "cp1-4",
    "data-name": "cp1",
    className: "cls-8",
    d: "M503.87,469.7l.33,8.69H493.89l.29-8.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "cp2-3",
    "data-name": "cp2",
    className: "cls-8",
    d: "M465.75,463.4h3v2.18h2.19v-2.23H474v2.22h2.19v-2.23h3.08v5a1.29,1.29,0,0,1-1.34,1.3H467.15a1.4,1.4,0,0,1-1.4-1.32v-5Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "cp2-4",
    "data-name": "cp2",
    className: "cls-8",
    d: "M492.27,463.4h3v2.18h2.19v-2.23h3.08v2.22h2.2v-2.23h3.07v5a1.29,1.29,0,0,1-1.34,1.3h-10.8a1.39,1.39,0,0,1-1.39-1.32v-5Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M484.75,467.32a1.09,1.09,0,1,1,2.17,0v3.85h-2.17v-3.84"
  }), /*#__PURE__*/React.createElement("path", {
    id: "cp3-3",
    "data-name": "cp3",
    d: "M471.43,472.9a1,1,0,1,1,2.06,0v3h-2.06v-3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "cp3-4",
    "data-name": "cp3",
    d: "M498,472.9a1,1,0,1,1,2.06,0v3H498v-3"
  })), /*#__PURE__*/React.createElement("g", {
    id: "castle-3",
    "data-name": "castle"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M520.63,622.41c-9.56-10-5-19.22-5-19.3s10-5,19.67,4.67l-14.71,14.63"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M502.72,616.53l10,12.39,7.31-7.33c-9.24-9.32-3.86-17.84-3.66-18s9.09-5,18,3.49l7.31-7.36-12.66-9.94-26.4,26.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M512.33,629.46l29.85-30.07a2,2,0,0,1,2.77,2.76L515.1,632.21a2,2,0,0,1-2.77-2.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M523.12,618.48c-5.84-5.87-3.55-11.5-3.53-11.52s5.84-2.45,11.7,3.29l-8.17,8.23"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M497,613l28.61-28.82a1.77,1.77,0,0,1,2.5,2.48l-28.61,28.82A1.77,1.77,0,0,1,497,613Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M500.09,614.84l27.38-27.56a1.78,1.78,0,0,1,2.49,2.48l-27.37,27.57a1.79,1.79,0,0,1-2.5-2.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M490.15,587.28l2.17-2.17,1.54,1.54,1.58-1.59-1.58-1.57,2.22-2.22,1.57,1.56,1.58-1.59-1.58-1.57,2.22-2.23,3.56,3.55a1.29,1.29,0,0,1,0,1.88l-7.77,7.83a1.41,1.41,0,0,1-1.94.09l-3.53-3.5h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M503.06,583.83,515,594.7l-7.6,7.61-10.95-11.88,6.62-6.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "cp1-5",
    "data-name": "cp1",
    className: "cls-9",
    d: "M499.12,598.41l6.4,5.89-7.27,7.32-6-6.33,6.83-6.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "cp1-6",
    "data-name": "cp1",
    className: "cls-9",
    d: "M517.81,579.59l6.4,5.89-7.27,7.32-6-6.33,6.84-6.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "cp2-5",
    "data-name": "cp2",
    className: "cls-9",
    d: "M486.47,602.2l2.12-2.12,1.55,1.53,1.54-1.55-1.58-1.57,2.17-2.18,1.58,1.57,1.55-1.56-1.58-1.57,2.17-2.18,3.56,3.54a1.3,1.3,0,0,1,0,1.87l-7.61,7.66a1.38,1.38,0,0,1-1.91.06l-3.54-3.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "cp2-6",
    "data-name": "cp2",
    className: "cls-9",
    d: "M505.16,583.38l2.12-2.12,1.55,1.53,1.54-1.55-1.58-1.57,2.17-2.18,1.58,1.57,1.55-1.56-1.59-1.57,2.18-2.18,3.56,3.54a1.3,1.3,0,0,1,0,1.87l-7.61,7.66a1.4,1.4,0,0,1-1.92.06l-3.53-3.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M502.65,591.48a1.08,1.08,0,1,1,1.52-1.53l2.73,2.7-1.53,1.54-2.72-2.71"
  }), /*#__PURE__*/React.createElement("path", {
    id: "cp3-5",
    "data-name": "cp3",
    d: "M497.21,604.87a1,1,0,1,1,1.46-1.47l2.1,2.09L499.32,607l-2.11-2.09"
  }), /*#__PURE__*/React.createElement("path", {
    id: "cp3-6",
    "data-name": "cp3",
    d: "M516,586a1,1,0,1,1,1.45-1.47l2.11,2.1-1.46,1.46L516,586"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "castle-4",
    "data-name": "castle"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M589.76,386.07C590.1,372.27,599.89,369,600,369s10.58,3.52,10.54,17.24l-20.74-.12"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M581.31,369.23l-1.7,15.86,10.35,0c.1-13.12,9.93-15.31,10.17-15.26s10,2.9,10.23,15.26h10.38l-1.87-16-37.56.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M578.91,385.15h42.36a2,2,0,0,1,0,3.91H578.91a2,2,0,0,1,0-3.91Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M594.31,385.07c.05-8.28,5.65-10.62,5.68-10.62s5.86,2.42,5.91,10.62H594.31"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M579.81,362.63h40.61a1.77,1.77,0,0,1,0,3.52H579.81a1.77,1.77,0,0,1,0-3.52Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M580.66,366.18H619.5a1.78,1.78,0,0,1,0,3.52H580.66a1.78,1.78,0,0,1,0-3.52Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M593.21,339.7h3.07v2.17h2.23v-2.22h3.15v2.21h2.24v-2.22H607v5a1.31,1.31,0,0,1-1.37,1.3h-11a1.42,1.42,0,0,1-1.43-1.32v-5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M604.76,346.43l.69,16.12-10.76,0,.72-16.13,9.35.05"
  }), /*#__PURE__*/React.createElement("path", {
    id: "cp1-7",
    "data-name": "cp1",
    className: "cls-8",
    d: "M591.63,353.9l.33,8.69H581.65l.29-8.7h9.69Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "cp1-8",
    "data-name": "cp1",
    className: "cls-8",
    d: "M618.16,353.9l.33,8.69H608.17l.29-8.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "cp2-7",
    "data-name": "cp2",
    className: "cls-8",
    d: "M580,347.6h3v2.18h2.2v-2.23h3.07v2.22h2.2v-2.23h3.07v5a1.29,1.29,0,0,1-1.34,1.3H581.44a1.39,1.39,0,0,1-1.4-1.32v-5Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "cp2-8",
    "data-name": "cp2",
    className: "cls-8",
    d: "M606.56,347.6h3v2.18h2.19v-2.23h3.07v2.22H617v-2.23h3.08v5a1.29,1.29,0,0,1-1.34,1.3H608a1.4,1.4,0,0,1-1.4-1.32v-5Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M599,351.53a1.09,1.09,0,1,1,2.17,0v3.84H599v-3.84"
  }), /*#__PURE__*/React.createElement("path", {
    id: "cp3-7",
    "data-name": "cp3",
    d: "M585.71,357.1a1,1,0,1,1,2.07,0v3h-2.07v-3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "cp3-8",
    "data-name": "cp3",
    d: "M612.31,357.1a1,1,0,1,1,2.07,0v3h-2.07v-3"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "castle3-2",
    "data-name": "castle3"
  }, /*#__PURE__*/React.createElement("g", {
    id: "castle-5",
    "data-name": "castle"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M724,386.07c-.33-13.8-10.13-17.07-10.2-17.11s-10.58,3.52-10.54,17.24l20.74-.12"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M732.45,369.23l1.71,15.86-10.35,0c-.1-13.12-9.94-15.31-10.18-15.26s-10,2.9-10.23,15.26H693l1.88-16,37.55.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M734.85,385.15H692.49a2,2,0,0,0,0,3.91h42.36a2,2,0,0,0,0-3.91Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M719.45,385.07c0-8.28-5.65-10.62-5.68-10.62s-5.85,2.42-5.9,10.62h11.58"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M734,362.63H693.34a1.77,1.77,0,0,0,0,3.52H734a1.77,1.77,0,0,0,0-3.52Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M733.1,366.18H694.26a1.78,1.78,0,0,0,0,3.52H733.1a1.78,1.78,0,0,0,0-3.52Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M720.55,339.7h-3.06v2.17h-2.24v-2.22h-3.14v2.21h-2.25v-2.22h-3.14v5a1.3,1.3,0,0,0,1.37,1.3h11a1.41,1.41,0,0,0,1.43-1.32v-5h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M709,346.43l-.69,16.12,10.76,0-.71-16.13-9.36.05"
  }), /*#__PURE__*/React.createElement("path", {
    id: "cp1-9",
    "data-name": "cp1",
    className: "cls-8",
    d: "M722.13,353.9l-.33,8.69h10.32l-.3-8.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "cp1-10",
    "data-name": "cp1",
    className: "cls-8",
    d: "M695.61,353.9l-.33,8.69h10.31l-.29-8.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "cp2-9",
    "data-name": "cp2",
    className: "cls-8",
    d: "M733.73,347.6h-3v2.18h-2.19v-2.23h-3.08v2.22h-2.19v-2.23h-3.08v5a1.29,1.29,0,0,0,1.34,1.3h10.79a1.4,1.4,0,0,0,1.4-1.32v-5Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "cp2-10",
    "data-name": "cp2",
    className: "cls-8",
    d: "M707.21,347.6h-3v2.18H702v-2.23h-3.08v2.22h-2.2v-2.23h-3.07v5a1.29,1.29,0,0,0,1.34,1.3h10.8a1.39,1.39,0,0,0,1.39-1.32v-5Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M714.73,351.53a1.09,1.09,0,1,0-2.17,0v3.84h2.17v-3.84"
  }), /*#__PURE__*/React.createElement("path", {
    id: "cp3-9",
    "data-name": "cp3",
    d: "M728.05,357.1a1,1,0,1,0-2.06,0v3h2.06v-3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "cp3-10",
    "data-name": "cp3",
    d: "M701.45,357.1a1,1,0,1,0-2.06,0v3h2.06v-3"
  })), /*#__PURE__*/React.createElement("g", {
    id: "castle-6",
    "data-name": "castle"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M724,501.87c-.33-13.8-10.13-17.07-10.2-17.11s-10.58,3.51-10.54,17.24l20.74-.13"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M732.45,485l1.71,15.87-10.35,0c-.1-13.12-9.94-15.31-10.18-15.26s-10,2.9-10.23,15.26H693l1.88-16,37.55.09h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M734.85,501H692.49a2,2,0,0,0,0,3.91h42.36a2,2,0,0,0,0-3.91Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M719.45,500.87c0-8.28-5.65-10.62-5.68-10.62s-5.85,2.42-5.9,10.62h11.58"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M734,478.42H693.34a1.78,1.78,0,0,0,0,3.53H734a1.78,1.78,0,0,0,0-3.53Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M733.1,482H694.26a1.79,1.79,0,0,0,0,3.53H733.1a1.79,1.79,0,0,0,0-3.53Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M720.55,455.5h-3.06v2.18h-2.24v-2.22h-3.14v2.21h-2.25v-2.22h-3.14v5a1.3,1.3,0,0,0,1.37,1.3h11a1.41,1.41,0,0,0,1.43-1.32v-5h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M709,462.22l-.69,16.13,10.76,0-.71-16.13-9.36,0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "cp1-11",
    "data-name": "cp1",
    className: "cls-8",
    d: "M722.13,469.7l-.33,8.69h10.32l-.3-8.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "cp1-12",
    "data-name": "cp1",
    className: "cls-8",
    d: "M695.61,469.7l-.33,8.69h10.31l-.29-8.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "cp2-11",
    "data-name": "cp2",
    className: "cls-8",
    d: "M733.73,463.4h-3v2.18h-2.19v-2.23h-3.08v2.22h-2.19v-2.23h-3.08v5a1.29,1.29,0,0,0,1.34,1.3h10.79a1.4,1.4,0,0,0,1.4-1.32v-5Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "cp2-12",
    "data-name": "cp2",
    className: "cls-8",
    d: "M707.21,463.4h-3v2.18H702v-2.23h-3.08v2.22h-2.2v-2.23h-3.07v5a1.29,1.29,0,0,0,1.34,1.3h10.8a1.39,1.39,0,0,0,1.39-1.32v-5Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M714.73,467.32a1.09,1.09,0,1,0-2.17,0v3.85h2.17v-3.84"
  }), /*#__PURE__*/React.createElement("path", {
    id: "cp3-11",
    "data-name": "cp3",
    d: "M728.05,472.9a1,1,0,1,0-2.06,0v3h2.06v-3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "cp3-12",
    "data-name": "cp3",
    d: "M701.45,472.9a1,1,0,1,0-2.06,0v3h2.06v-3"
  })), /*#__PURE__*/React.createElement("g", {
    id: "castle-7",
    "data-name": "castle"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M678.85,622.41c9.56-10,5-19.22,5-19.3s-9.95-5-19.67,4.67l14.71,14.63"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M696.76,616.53l-10,12.39-7.31-7.33c9.24-9.32,3.86-17.84,3.66-18s-9.09-5-18,3.49l-7.31-7.36,12.66-9.94,26.4,26.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M687.15,629.46,657.3,599.39a2,2,0,0,0-2.77,2.76l29.85,30.06a2,2,0,0,0,2.77-2.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M676.36,618.48c5.84-5.87,3.55-11.5,3.53-11.52s-5.84-2.45-11.7,3.29l8.17,8.23"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M702.5,613l-28.61-28.82a1.77,1.77,0,0,0-2.5,2.48L700,615.43a1.77,1.77,0,0,0,2.5-2.48Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M699.39,614.84,672,587.28a1.78,1.78,0,0,0-2.49,2.48l27.37,27.57a1.79,1.79,0,0,0,2.5-2.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M709.33,587.28l-2.17-2.17-1.54,1.54L704,585.06l1.58-1.57-2.22-2.22-1.57,1.56-1.58-1.59,1.58-1.57-2.22-2.23L696.05,581a1.29,1.29,0,0,0,0,1.88l7.77,7.83a1.41,1.41,0,0,0,1.94.09l3.53-3.5h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M696.42,583.83,684.49,594.7l7.6,7.61L703,590.43l-6.62-6.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "cp1-13",
    "data-name": "cp1",
    className: "cls-9",
    d: "M700.36,598.41,694,604.3l7.27,7.32,6-6.33-6.83-6.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "cp1-14",
    "data-name": "cp1",
    className: "cls-9",
    d: "M681.67,579.59l-6.4,5.89,7.27,7.32,6-6.33-6.83-6.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "cp2-13",
    "data-name": "cp2",
    className: "cls-9",
    d: "M713,602.2l-2.12-2.12-1.55,1.53-1.54-1.55,1.58-1.57-2.17-2.18-1.58,1.57-1.55-1.56,1.58-1.57-2.17-2.18-3.56,3.54a1.3,1.3,0,0,0,0,1.87l7.61,7.66a1.38,1.38,0,0,0,1.91.06l3.54-3.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "cp2-14",
    "data-name": "cp2",
    className: "cls-9",
    d: "M694.32,583.38l-2.12-2.12-1.55,1.53-1.54-1.55,1.58-1.57-2.17-2.18-1.58,1.57-1.55-1.56,1.59-1.57-2.18-2.18-3.56,3.54a1.3,1.3,0,0,0,0,1.87l7.61,7.66a1.4,1.4,0,0,0,1.92.06l3.53-3.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M696.83,591.48a1.08,1.08,0,1,0-1.52-1.53l-2.73,2.7,1.53,1.54,2.72-2.71"
  }), /*#__PURE__*/React.createElement("path", {
    id: "cp3-13",
    "data-name": "cp3",
    d: "M702.27,604.87a1,1,0,1,0-1.46-1.47l-2.1,2.09,1.45,1.47,2.11-2.09"
  }), /*#__PURE__*/React.createElement("path", {
    id: "cp3-14",
    "data-name": "cp3",
    d: "M683.52,586a1,1,0,1,0-1.45-1.47l-2.11,2.1,1.46,1.46,2.1-2.09"
  })))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "quina"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M581.59,506h0a20.82,20.82,0,0,0,5.53,14.22,17.77,17.77,0,0,0,26.51,0,20.82,20.82,0,0,0,5.51-14.23V479.13l-37.48,0L581.59,506"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-11",
    cx: 590.19,
    cy: 489.34,
    r: 3.71
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-11",
    cx: 610.98,
    cy: 489.36,
    r: 3.71
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-11",
    cx: 600.56,
    cy: 499.34,
    r: 3.71
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-11",
    cx: 590.19,
    cy: 509.79,
    r: 3.71
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-11",
    cx: 610.96,
    cy: 509.76,
    r: 3.71
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "quina-2",
    "data-name": "quina"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M581.59,441h0a20.82,20.82,0,0,0,5.53,14.22,17.77,17.77,0,0,0,26.51,0A20.82,20.82,0,0,0,619.14,441V414.09l-37.48,0L581.59,441"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-11",
    cx: 590.19,
    cy: 424.3,
    r: 3.71
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-11",
    cx: 610.98,
    cy: 424.32,
    r: 3.71
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-11",
    cx: 600.56,
    cy: 434.3,
    r: 3.71
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-11",
    cx: 590.19,
    cy: 444.75,
    r: 3.71
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-11",
    cx: 610.96,
    cy: 444.72,
    r: 3.71
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "quina-3",
    "data-name": "quina"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M529.59,506h0a20.86,20.86,0,0,0,5.53,14.22,17.77,17.77,0,0,0,26.51,0,20.82,20.82,0,0,0,5.51-14.23V479.13l-37.48,0L529.59,506"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-11",
    cx: 538.19,
    cy: 489.34,
    r: 3.71
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-11",
    cx: 558.98,
    cy: 489.36,
    r: 3.71
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-11",
    cx: 548.57,
    cy: 499.34,
    r: 3.71
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-11",
    cx: 538.19,
    cy: 509.79,
    r: 3.71
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-11",
    cx: 558.96,
    cy: 509.76,
    r: 3.71
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "quina-4",
    "data-name": "quina"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M633.45,506h0A20.86,20.86,0,0,0,639,520.25a17.77,17.77,0,0,0,26.51,0A20.82,20.82,0,0,0,671,506.05V479.13l-37.48,0L633.45,506"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-11",
    cx: 642.05,
    cy: 489.34,
    r: 3.71
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-11",
    cx: 662.84,
    cy: 489.36,
    r: 3.71
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-11",
    cx: 652.43,
    cy: 499.34,
    r: 3.71
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-11",
    cx: 642.05,
    cy: 509.79,
    r: 3.71
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-11",
    cx: 662.82,
    cy: 509.76,
    r: 3.71
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    id: "quina-5",
    "data-name": "quina"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M581.59,570.48h0a20.82,20.82,0,0,0,5.53,14.22,17.77,17.77,0,0,0,26.51,0,20.82,20.82,0,0,0,5.51-14.23V543.59l-37.48,0-.07,26.91"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-11",
    cx: 590.19,
    cy: 553.8,
    r: 3.71
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-11",
    cx: 610.98,
    cy: 553.82,
    r: 3.71
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-11",
    cx: 600.56,
    cy: 563.8,
    r: 3.71
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-11",
    cx: 590.19,
    cy: 574.25,
    r: 3.71
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-11",
    cx: 610.96,
    cy: 574.22,
    r: 3.71
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlagPt);
export default __webpack_public_path__ + "static/media/flag_pt.cda6429a6954dbebdcb381cd9ebc4dfb.svg";
export { ForwardRef as ReactComponent };